module.exports = __webpack_public_path__ + "static/1396929791-wide.501ca4c4.jpg";